import { useEffect, useState } from "react";
import OrganizationNameHeader from "../common/OrganizationNameHeader/OrganizationNameHeader";
import { useGeneratePdfContext } from "../../utils/context/GeneratePdfContext";
import { GetImages } from "../../utils/GetImages";

const PrintLayout = ({ children, isPrint, hideHeader = false }) => {
  const [topValue, setTopValue] = useState<number | undefined>(undefined);
  const [height, setHeight] = useState<string>("");
  const { orgDetails, statementData, subHeaderName } = useGeneratePdfContext();

  // const logoImageBase64 = orgDetails?.logoImageBase64?.trim();

  // const OrgImg =
  //     logoImageBase64 && logoImageBase64.length > 0
  //         ? `data:image/png;base64,${logoImageBase64}`
  //         : GetImages.HomeBlackFilled;

  useEffect(() => {
    if (statementData) {
      const header = document.querySelector(
        ".PropertyList_View_Header",
      ) as HTMLElement;

      if (header) {
        const headerHeight = header.offsetHeight;
        setTopValue(220 + headerHeight);
        setHeight(`calc(100vh - 322px - ${headerHeight}px)`);
      } else {
        setTopValue(210);
        setHeight(`calc(100vh - 322px)`);
      }
    }

    if (
      (statementData &&
        statementData?.incomeItems?.length == 0 &&
        statementData &&
        statementData?.expenseItems?.length == 0) ||
      (statementData && statementData?.rentRollItems?.length == 0)
    ) {
      const header = document.querySelector(
        ".PropertyList_View_Header",
      ) as HTMLElement;

      if (header) {
        const headerHeight = header.offsetHeight;
        setTopValue(220 + headerHeight);
        setHeight(`calc(100vh - 322px - ${headerHeight}px)`);
      } else {
        setTopValue(210);
        setHeight(`calc(100vh - 322px)`);
      }
    }
  }, [statementData]);

  return (
    <>
      <div
        className="generatePdfDoc"
        data-theme="light"
        style={{
          top: isPrint ? "unset" : `${topValue}px`,
          height: isPrint ? "unset" : height,
          overflow: isPrint ? "unset" : "scroll",
          position: isPrint ? "unset" : "absolute",
          width: isPrint ? "100%" : "calc(100vw - 280px)",
          backgroundColor: "white",
        }}
      >
        <table
          className="print-component"
          style={{
            overflow: isPrint ? "unset" : "scroll",
            position: isPrint ? "unset" : "absolute",
            width: isPrint ? "100%" : "calc(100vw - 295px)",
          }}
        >
          <tbody>
            {isPrint && !hideHeader && (
              <tr>
                <td>
                  <OrganizationNameHeader
                    SubHeaderName={subHeaderName}
                    element={undefined}
                    OrgName={orgDetails?.name}
                    OrgImg={
                      orgDetails?.logoImageBase64 !== ""
                        ? `data:image/png;base64,${orgDetails?.logoImageBase64}`
                        : null
                    }
                  />
                </td>
              </tr>
            )}
            <tr>
              <td>{children}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PrintLayout;
